// extracted by mini-css-extract-plugin
export default {"IndexLayout":"IndexLayout_IndexLayout__ZM9Rf"};